import { announcementsLinks } from '@/backend/routes';
import { AnnouncementColumns } from '@juvare/announcements/backend/features/announcements';
import { AnnouncementCreateOrEdit } from '@juvare/announcements/ui/features/announcements';
import { DefaultFormWidgetConfigTypes } from '@juvare/common-form-ui/WidgetForm/types';
import { AppPage } from '@juvare/common-web-ui/AppPage';
import { AppPageHeader2 } from '@juvare/common-web-ui/AppPageHeader2';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { WidgetAccessByOrganizationConfig } from '@juvare/contact-management/ui/features/forms/form-widgets/types';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { Row } from '@juvare/platform-shared/features/storage';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

export const AnnouncementsForm = () => {
    const location = useLocation();
    const announcement = (location.state as { entity: Row<AnnouncementColumns> }) || undefined;
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const userState = useUserState();
    const { t } = useTranslation();

    const navigateToAnnouncements = () => {
        navigate(announcementsLinks.root);
    };

    return (
        <AppPage
            contentPadding={2}
            contentScrollable={true}
            header={
                <AppPageHeader2
                    title={t('pages.home.title')}
                    subTitle={t('pages.announcements.title')}
                    onBack={() =>
                        navigationContext.navigate(() => {
                            navigateToAnnouncements();
                        }, true)
                    }
                />
            }
            contentWidth={800}
        >
            <AnnouncementCreateOrEdit
                onEditAnnouncement={navigateToAnnouncements}
                onCreateAnnouncement={navigateToAnnouncements}
                announcementData={
                    announcement?.entity
                        ? {
                              ...announcement.entity,
                              columns: {
                                  ...announcement.entity.columns,
                                  access: {
                                      public: announcement.entity.columns.public,
                                      visibility: announcement.entity.columns.visibility,
                                  },
                                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              } as any,
                          }
                        : undefined
                }
                extendedConfig={
                    [
                        {
                            type: 'contactManagement.accessByOrganization',
                            label: 'Access',
                            key: 'access',
                            hidePublicOption: !requireAnySystemPermission(userState, 'manage-announcements'),
                        },
                    ] as DefaultFormWidgetConfigTypes<WidgetAccessByOrganizationConfig>[] as DefaultFormWidgetConfigTypes[]
                }
            />
        </AppPage>
    );
};
